// @flow

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class AudioToggle extends PureComponent {
  static defaultProps = {
    alias: '',
    theme: '',
    fieldFile: '',
  };

  static propTypes = {
    alias: PropTypes.string.isRequired,
    theme: PropTypes.string.isRequired,
    fieldFile: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.audio = false;

    this.state = {
      durationTime: '',
      durationPercent: 0,
      isPlaying: false,
    };
  }

  componentDidMount() {
    if (this.props.fieldFile !== '') {
      this.mountAudio(this.props.fieldFile);
    }
  }

  componentWillReceiveProps(nextProps) {
    // Use alias instead of fieldFile since the file could be the same file.
    if (nextProps.alias !== this.props.alias) {
      if (this.audio) {
        this.dismountAudio();
      }

      if (nextProps.fieldFile !== '') {
        this.mountAudio(nextProps.fieldFile);
      }
    }
  }

  componentWillUnmount() {
    if (this.audio) {
      this.dismountAudio();
    }
  }

  mountAudio(src) {
    this.audio = global.document.createElement('audio');
    this.audio.src = src;
    this.audio.addEventListener('canplaythrough', this.playAudio.bind(this));
    this.audio.addEventListener('timeupdate', this.updateAudioTime.bind(this));
    this.audio.addEventListener('ended', this.pauseAudio.bind(this));
  }

  dismountAudio() {
    this.pauseAudio();
    this.audio.removeEventListener('canplaythrough', this.playAudio.bind(this));
    this.audio.removeEventListener(
      'timeupdate',
      this.updateAudioTime.bind(this),
    );
    this.audio = false;

    this.setState({
      durationPercent: 0,
    });
  }

  playAudio() {
    if (this.audio) {
      this.setState({
        isPlaying: true,
      });
      this.audio.play();
    }
  }

  pauseAudio() {
    if (this.audio) {
      this.setState({
        isPlaying: false,
      });
      this.audio.pause();
    }
  }

  toggleAudio() {
    if (this.state.isPlaying) {
      this.pauseAudio();
    } else {
      this.playAudio();
    }
  }

  updateAudioTime() {
    const duration = parseInt(this.audio.duration, 10);
    const currentTime = parseInt(this.audio.currentTime, 10);
    const timeLeft = duration - currentTime;

    // Get the duration percentage.
    // See here: https://j11y.io/javascript/double-bitwise-not/
    /* eslint-disable no-bitwise */
    let number = ~~(currentTime / duration * 10000);
    // Quit early if the number is zero.
    if (number === 0) {
      this.setState({
        durationTime: '',
        durationPercent: 0,
      });
      return;
    }
    number /= 10000;
    number *= 100;
    /* eslint-enable no-bitwise */

    // Get the duration time left.
    const seconds = timeLeft % 60;
    const minutes = Math.floor(timeLeft / 60) % 60;
    const hours = Math.floor(timeLeft / 3600) % 24;

    const secondsText = seconds < 10 ? `0${seconds}` : seconds;
    const minutesText = minutes < 10 ? `0${minutes}` : minutes;
    const timeLeftText = `${minutesText} : ${secondsText}`;

    this.setState({
      durationTime: hours ? `${hours} : ${timeLeftText}` : timeLeftText,
      durationPercent: Math.ceil(number),
    });
  }

  /* eslint-disable react/jsx-no-bind */
  render() {
    const buttonState = this.state.isPlaying ? 'playing' : 'paused';
    const audioAvailable = this.props.fieldFile === '' ? ' is-hidden' : '';

    return (
      <div className={`wheel__audio-toggle${audioAvailable}`}>
        <div
          className={`radial-progress theme--${this.props.theme}`}
          data-progress={this.state.durationPercent}
        >
          <div className="radial-progress__circle">
            <div className="radial-progress__mask radial-progress__mask--full">
              <div className="radial-progress__fill" />
            </div>
            <div className="radial-progress__mask half">
              <div className="radial-progress__fill" />
              <div className="radial-progress__fill radial-progress__fill--fix" />
            </div>
          </div>
          <button
            className={`btn btn--audio btn--${buttonState} center center--both`}
            onClick={this.toggleAudio.bind(this)}
            onMouseDown={event => {
              // Prevent focus.
              event.preventDefault();
            }}
          >
            <span className="visually-hidden">
              {this.state.isPlaying ? 'Play' : 'Pause'}
            </span>
            <span className="btn__child svg-wrapper icon--tiny center center--both theme--white">
              <svg aria-hidden="true" focusable="false">
                <use xlinkHref="#icon-play" />
              </svg>
            </span>
          </button>
        </div>
        <span className="h3 h3--medium theme--white hide-on-mobile">
          {this.state.durationTime}
        </span>
      </div>
    );
  }
  /* eslint-enable react/jsx-no-bind */
}

export default AudioToggle;



// WEBPACK FOOTER //
// ./screens/App/components/AudioToggle/index.js